import { BrandTokens } from "../../../@tokens/BrandTokens";
import { GlobalTokens } from "../../../@tokens/GlobalTokens";
import { hexToRGB } from "../../../helpers/Colors/colors";

export const style: any = {
    theme: {
        borderRadius: GlobalTokens.BorderRadiusPill,
        minWidth: '140px',
        fontFamily: BrandTokens.FontFamily,
        fontSize: GlobalTokens.FontSizeXs,
        fontWeight: BrandTokens.FontWeightMedium,
        lineHeight: GlobalTokens.LineHeightDefault,
        textAlign: 'center',
        height: '48px',
        padding: `12px ${GlobalTokens.SpacingSizeMd}`,
  
        motion: {
            transitionDuration: GlobalTokens.MotionSwitchSlow?.TransitionDuration,
            transitionTimingFunction: GlobalTokens.MotionSwitchSlow?.TransitionTimingFunction
        },

  
        primary: {
          backgroundColor: BrandTokens.BrandColorPrimaryPure,
          border: 'none',
          color: BrandTokens.NeutralColorHighPure,
        },
  
        secondary: {
          backgroundColor: 'transparent',
          border: `${GlobalTokens.BorderWidthHairline} solid ${BrandTokens.BrandColorPrimaryPure}`,
          color: BrandTokens.BrandColorPrimaryPure,
          fontWeight: BrandTokens.FontWeightRegular,
        },
  
        sizes: {
          sm: {
            height: '40px',
            padding: `${GlobalTokens.SpacingInsetSizeNano} ${GlobalTokens.SpacingInsetSizeXs}`,
            icon: {
              paddingRight: GlobalTokens.SpacingInsetSizeNano
            }
          },
  
          lg: {
            height: '56px',
            padding: `${GlobalTokens.SpacingInsetSizeXs} ${GlobalTokens.SpacingInsetSizeMd}`,
            icon: {
              paddingRight: GlobalTokens.SpacingInsetSizeNano
            }
          }
        },
  
        states: {
          hover: {
            backgroundColor: BrandTokens.BrandColorPrimaryLight,
            borderColor: 'transparent',
            color: BrandTokens.BrandColorPrimaryDark
          },
  
          focus: {
            outline: `${GlobalTokens.BorderWidthThin} solid ${BrandTokens.HighlightColorPure}`,
            outlineOffset: GlobalTokens.BorderWidthThin
          },
  
          disabled: {
            backgroundColor: hexToRGB(BrandTokens.NeutralColorLowPure, GlobalTokens.OpacityLevelSemitransparent),
            border: 'none',
            color: hexToRGB(BrandTokens.NeutralColorLowPure, GlobalTokens.OpacityLevelMedium)
          }
        }
      }
}